import { store } from 'store/index'
import { messagesActions, selectChatId } from 'store/messages'
import { captchaAxios } from 'api/config'
import ObjectID from 'bson-objectid'

// question -> Domanda
// answer -> Risposta
export const askBotAnswer = async ({ question, questionId }: { question: string; questionId: string }) => {
  const state = store.getState()
  const chatId = selectChatId(state)
  const answerId = String(ObjectID())

  console.debug({
    answerId,
    questionId,
  })

  try {
    store.dispatch(messagesActions.setUserTyping(false))
    await captchaAxios.post(`chats/${chatId}/answer/bot`, undefined, {
      params: {
        question,
        questionId,
        answerId,
      },
    })
  } catch (error) {
    store.dispatch(messagesActions.endBotResponse())
    return Promise.reject(error)
  }
}
